import styled from "styled-components";

import Text from "components/atoms/text/Text";

// region: Breadcrumb
const BreadcrumbContainer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: end;
    justify-content: space-between;
    padding: 0 48px;
    margin-bottom: 32px;
    height: 64px;
    max-height: 64px;
    background-color: var(--color-White);
`;

export const BreadcrumbTitle = styled(Text).attrs({
    variant: "styled-lg",
    fontWeight: "500",
    color: "var(--color-Black)",
})``;

export function Breadcrumb({ children, ...rest }) {
    return <BreadcrumbContainer {...rest}>{children}</BreadcrumbContainer>;
}

// region: Body
const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 96px 0 0 0;
    padding: 0 48px;
    width: 100%;
    height: calc(100vh - 152px);
    overflow: auto;
`;

export function BodyWithBreadcrumb({ children, ...rest }) {
    return <BodyContainer {...rest}>{children}</BodyContainer>;
}

export default Breadcrumb;
